import { StepsState } from "../../../model/global"

const initialState: StepsState = {
	formSubmitUrl: '',
	formSubmitError: '',
	requestedStepIndex: -1,
	activeStepIndex: 0,
	formIsSubmitted: false,
	steps: [],
	formSummary: {
		steps: {
			MAIN_ENQUIRY: {},
			CUSTOMER_INFORMATION: {},
			RECEIVER_INFORMATION:{},
			AGENT_INFORMATION: {},
			FORM_SUMMARY: {},
		},
		initialized: {
			MAIN_ENQUIRY: false,
			CUSTOMER_INFORMATION: false,
			RECEIVER_INFORMATION: false,
			AGENT_INFORMATION: false,
			FORM_SUMMARY: false,
		},
		validationErrors: {
			MAIN_ENQUIRY: {},
			CUSTOMER_INFORMATION:{},
			RECEIVER_INFORMATION: {},
			AGENT_INFORMATION: {},
			FORM_SUMMARY: {},
		},
		validatedSteps: {
			MAIN_ENQUIRY: false,
			CUSTOMER_INFORMATION:false,
			RECEIVER_INFORMATION: false,
			AGENT_INFORMATION: false,
			FORM_SUMMARY: false,
		},
		validatedStepsHTML5: {
			MAIN_ENQUIRY: false,
			CUSTOMER_INFORMATION:false,
			RECEIVER_INFORMATION: false,
			AGENT_INFORMATION: false,
			FORM_SUMMARY: false,
		},
		validatedSerialOrOrderNumber: false
	},
	endScreen: {
		headline: {
			text: '',
		},
		text: '',
		button: {
			href: '',
			title: '',
			text: '',
			target: '_self',
		},
	}
}
export default initialState
